const listePagesAdherent = [
  {
    libelle: 'Tableau de bord',
    route: '/tableau-de-bord'
  },
  {
    libelle: 'Mes apports',
    route: '/mes-recoltes'
  },
  {
    libelle: 'Mes outils d\'analyse',
    route: '/mes-outils-d-analyse'
  },
  {
    libelle: 'Mes contrats',
    route: '/mes-contrats'
  },
  {
    libelle: 'Mes cultures',
    route: '/mes-cultures'
  },
  {
    libelle: 'Mon compte',
    route: '/compte'
  },
  {
    libelle: 'Comparateur de marges',
    route: '/mes-cultures/comparateur-marge-adherent'
  }
]

export default listePagesAdherent
